import { SystemText } from 'e4shared';
import { ratingColour } from 'helpers/metrics';
import React from 'react';
import { useSelector } from 'react-redux';

export const CompetencyRating = ({ badge, level, hideOutOf, hideUnrated, hideColour, onChange, onClick, readonly }) => {
    const [editMode, setEditMode] = React.useState(false);
    const rater = React.useRef(null);
    const user = useSelector(state => (state.user.user ? state.user.user : ''));
    const ratings = user.companySettings?.display?.ratingRange || 5;

    const setRating = value => {
        if (editMode) {
            setEditMode(false);
            const newLevel = value;
            if (level !== newLevel) {
                onChange(newLevel);
            }
        }
    };

    React.useEffect(() => {
        document.addEventListener('mousedown', handleClick, false);

        return () => {
            document.removeEventListener('mousedown', handleClick, false);
        };
    }, []);

    const handleClick = e => {
        if (rater.current && !rater.current.contains(e.target)) {
            setEditMode(false);
        }
    };

    const onClickFire = onChange ? () => setEditMode(true) : onClick ? onClick : null;

    const labelStyle = rating => {
        if (hideColour) return 'label-default';

        return `label-${ratingColour(rating)}`;
    };

    const rating = !level ? (
        <span key="rating0">
            {onClickFire ? (
                <button
                    onClick={onClickFire}
                    title={SystemText('Reviews/Components/CompetencyRater/ClickToRate')}
                    className="btn btn-sm btn-danger"
                >
                    {SystemText('Reviews/Components/CompetencyRater/RateMe')}
                    <i className="fa fa-caret-down ml10" />
                </button>
            ) : (
                !hideUnrated && <span className="unrated">{SystemText('Reviews/Components/CompetencyRater/Unrated')}</span>
            )}
        </span>
    ) : (
        <span key="rating_1" className="competency-rater">
            {onClickFire ? (
                <button
                    onClick={onClickFire}
                    title={SystemText('Reviews/Components/CompetencyRater/ClickToRate')}
                    className={`btn btn-sm btn-${hideColour ? 'default' : ratingColour(level)}`}
                >
                    {`${level}${hideOutOf ? '' : ` / ${ratings}`}`}
                    <i className="fa fa-caret-down ml10" />
                </button>
            ) : (
                <label className={`p10 no-wrap rating-label  ${!badge ? 'label-default' : labelStyle(level)}`}>{`${level}${
                    hideOutOf ? '' : ` / ${ratings}`
                }`}</label>
            )}
        </span>
    );

    const editor = (
        <span key="rating-editor" className="rating-editor" style={{ top: '0', left: '20px' }}>
            <div ref={rater}>
                <div onClick={() => setEditMode(false)}>
                    <span className="mr5">{level}</span>
                    <i className="fa fa-caret-down" />
                </div>
                {[...Array(ratings).keys()].map(r => {
                    r++;
                    return (
                        <div className="option" key={`rating-${r}`} onClick={() => setRating(r)}>
                            {r}
                        </div>
                    );
                })}
            </div>
        </span>
    );

    return <span>{editMode ? editor : rating}</span>;
};

export default CompetencyRating;
